module.exports = __webpack_public_path__ + "media/coffee-preferences/adventurousness_high-139dcc1b.png";